import { CMS_HTTP_INTERCEPTORS } from './cms-http-interceptors.token';
import { AuthHeadersInterceptor } from '../../auth/cms/interceptors/auth-headers.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { HeadersInterceptor } from '../base/interceptors/headers.interceptor';
import { AuthErrorInterceptor } from '../../auth/cms/interceptors/auth-error.interceptor';
import { ForbiddenInterceptor } from './interceptors/forbidden.interceptor';
import { DryRunInterceptor } from '../base/interceptors/dry-run.interceptor';

export const interceptorProviders = [
  { provide: CMS_HTTP_INTERCEPTORS, useClass: AuthHeadersInterceptor, multi: true },
  { provide: CMS_HTTP_INTERCEPTORS, useClass: HeadersInterceptor, multi: true },
  { provide: CMS_HTTP_INTERCEPTORS, useClass: DryRunInterceptor, multi: true },
  { provide: CMS_HTTP_INTERCEPTORS, useClass: AuthErrorInterceptor, multi: true },
  { provide: CMS_HTTP_INTERCEPTORS, useClass: ForbiddenInterceptor, multi: true },
  { provide: CMS_HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }
];
